import React from 'react';
import cn from 'classnames';
import InteractChatButton from 'extracted-chat-components/src/components/InteractChatButton';
import { ButtonColor, ButtonSize } from 'extracted-chat-components/enums';

import CustomTooltip from 'components/Tooltips/CustomTooltip';

import style from '../style.module.scss';

interface AutoReloadSectionProps {
  toggleButtonLabel: string;
  toggleTooltipButtonRef: React.RefObject<HTMLButtonElement>;
  handleToggleTooltipVisible: Function;
  isToggleTooltipVisible: boolean;
  isAutoReloadEnabled: boolean;
  autoreloadChatToggleTooltipText1: string;
  autoreloadChatToggleTooltipText2: string;
  handleAutoReloadChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sliderCn: string;
  sliderInner: string;
  toggleInfoLabel: string;
  acceptButtonText: string;
  cancelButtonHadler: any;
  acceptButton: {
    handler: () => void;
    size: ButtonSize;
    color: ButtonColor;
  };
  isPrimaryPaymentMethod: boolean;
}

const AutoReloadSection: React.FC<AutoReloadSectionProps> = ({
  toggleButtonLabel,
  toggleTooltipButtonRef,
  handleToggleTooltipVisible,
  isToggleTooltipVisible,
  isAutoReloadEnabled,
  autoreloadChatToggleTooltipText1,
  autoreloadChatToggleTooltipText2,
  handleAutoReloadChange,
  sliderCn,
  sliderInner,
  toggleInfoLabel,
  acceptButtonText,
  acceptButton,
  cancelButtonHadler,
  isPrimaryPaymentMethod,
}) => {
  const toggleContainer = cn(
    style.toggleContainer, {
      [style.toggleContainerHeight]: isAutoReloadEnabled,
      [style.toggleContainerOverflow]: isToggleTooltipVisible,
    },
  );

  if (!isPrimaryPaymentMethod) {
    return (
      <div className={style.addFundsContainer}>
        <button
          type="button"
          id="gotoAddFundsButton"
          className={style.addFundsButton}
          onClick={cancelButtonHadler}
        >
          Go to Add Funds
        </button>
        <button
          type="button"
          className={style.addFundsCancel}
          onClick={cancelButtonHadler}
        >
          Cancel
        </button>
      </div>
    );
  }

  return (
    <>
      <div className={toggleContainer}>
        <div className={style.toggleWrapper}>
          <div className={cn(style.toggleMessage, {
            [style.toggleMessageSize]: isAutoReloadEnabled,
          })}
          >
            {toggleButtonLabel}
            <button
              type="button"
              className={style.toggleInfoBtn}
              ref={toggleTooltipButtonRef}
              onClick={handleToggleTooltipVisible()}
              onBlur={handleToggleTooltipVisible(true)}
            >
              <span className={style.topMessageInfo}>i</span>
              <CustomTooltip
                isOpen={isToggleTooltipVisible}
                classNames={cn(style.toggleTooltip, {
                  [style.toggleTooltipOn]: isAutoReloadEnabled,
                })}
              >
                <span>
                  {autoreloadChatToggleTooltipText1}
                </span>
                <span>
                  {autoreloadChatToggleTooltipText2}
                </span>
              </CustomTooltip>
            </button>
          </div>
          <div className={style.autoReloadToggleContainer}>
            <div className={style.sliderContainer}>
              <label htmlFor="autoReloadToggle" className={style.autoReloadToggleButton}>
                <input
                  checked={isAutoReloadEnabled}
                  type="checkbox"
                  id="autoReloadToggle"
                  onChange={handleAutoReloadChange}
                />
                <span className={sliderCn}>
                  <div className={sliderInner}>
                    {isAutoReloadEnabled ? 'ON' : 'OFF'}
                  </div>
                </span>
              </label>
            </div>
          </div>
        </div>
        <span className={style.toggleInfo}>
          {toggleInfoLabel}
        </span>
      </div>
      <div className={style.containerModalButtons}>
        <div className={style.containerModalButtonsAccept}>
          <InteractChatButton
            isActive
            icon={null}
            text={acceptButtonText}
            onClick={acceptButton.handler}
            size={acceptButton.size}
            color={acceptButton.color}
            className={style.containerModalButtonsAddFunds}
          />
        </div>
      </div>
    </>
  );
};

export default AutoReloadSection;
